<template>
  <div id="app" :class="$route.path == '/fale-conosco' ? 'contact-us' : ''">
    <Header v-if="$route.path !== '/links'" id="header" :class=" scrollY > 270 ? 'hideScroll' : ''"></Header>
    <transition name="fade" mode="out-in">
      <router-view id="content"/>
    </transition>
    <Footer id="footer"></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: {
    Header,
    Footer
  },
  data () {
    return {
      scrollY: window.scrollY
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      this.scrollY = window.scrollY
    })
  },
  watch: {
    $route () {
      this.scrollToTop()
      if (this.$route.path === '/area-dos-representantes' || this.$route.path === '/links' || this.$route.path === '/catalogos') {
        document.querySelector('body').style.background = '#005245'
      } else {
        document.querySelector('body').style.background = '#eee'
      }
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss">
@import './assets/scss/index.scss';

#app {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
#header, #content, #footer {
  width: 100.5%;
}
#header {
  position: fixed;
  z-index: 2;
  transition: all .4s ease;
  background-color: rgba(0, 82, 69, 0.38);
}
@media screen and (min-width: 768px){
  .hideScroll {
    transition: all .1s ease;
    position: fixed !important;
    background-color: #e9e9e9 !important;
    opacity: 1;
    box-shadow: 0px 3px 3px rgba(80, 80, 80, 0.32);
    a {
      color: #005245 !important;
    }
    a:after {
      background-color: #005245 !important;
    }
    ul li a {
      color: #FAFAFA !important;
    }
  }
  .hideScroll:hover {
    opacity: .99;
  }
}
#content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 60px 0;
}
#footer {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 20px;
}
</style>